/**
 * Optimized Third-Party Script Loader
 * Handles consent-based loading and performance optimization
 */
(function() {
  'use strict';
  
  // Configuration for third-party scripts
  const SCRIPTS = {
    tally: {
      src: 'https://tally.so/widgets/embed.js',
      async: true,
      consent: 'marketing',
      priority: 'low'
    },
    msUet: {
      src: '//bat.bing.com/bat.js',
      async: true,
      consent: 'marketing',
      priority: 'medium'
    }
  };
  
  // Consent management
  function hasConsent(type) {
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.getMarketingConsent === 'function') {
        return Shopify.customerPrivacy.getMarketingConsent();
      }
      // Default to true if no consent system
      return true;
    } catch(e) {
      console.warn('Consent check failed:', e);
      return true;
    }
  }
  
  // Script loader with performance optimization
  function loadScript(config) {
    return new Promise((resolve, reject) => {
      // Check if already loaded
      if (document.querySelector(`script[src="${config.src}"]`)) {
        resolve();
        return;
      }
      
      // Check consent
      if (config.consent && !hasConsent(config.consent)) {
        console.log(`Script ${config.src} blocked due to consent: ${config.consent}`);
        resolve(); // Resolve without loading
        return;
      }
      
      const script = document.createElement('script');
      script.src = config.src;
      script.async = config.async !== false;
      script.crossOrigin = 'anonymous';
      
      script.onload = () => {
        console.log(`Script loaded: ${config.src}`);
        resolve();
      };
      
      script.onerror = () => {
        console.warn(`Script failed to load: ${config.src}`);
        reject(new Error(`Failed to load: ${config.src}`));
      };
      
      // Add to document
      document.head.appendChild(script);
    });
  }
  
  // Load scripts based on priority and consent
  function loadScriptsByPriority() {
    const highPriority = Object.entries(SCRIPTS).filter(([_, config]) => config.priority === 'high');
    const mediumPriority = Object.entries(SCRIPTS).filter(([_, config]) => config.priority === 'medium');
    const lowPriority = Object.entries(SCRIPTS).filter(([_, config]) => config.priority === 'low');
    
    // Load high priority immediately
    highPriority.forEach(([name, config]) => {
      loadScript(config).catch(console.warn);
    });
    
    // Load medium priority after a short delay
    setTimeout(() => {
      mediumPriority.forEach(([name, config]) => {
        loadScript(config).catch(console.warn);
      });
    }, 1000);
    
    // Load low priority after page load
    window.addEventListener('load', () => {
      setTimeout(() => {
        lowPriority.forEach(([name, config]) => {
          loadScript(config).catch(console.warn);
        });
      }, 2000);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadScriptsByPriority);
  } else {
    loadScriptsByPriority();
  }
  
  // Expose loader for manual use
  window.ThirdPartyLoader = {
    loadScript,
    hasConsent,
    loadScriptsByPriority
  };
  
})();
